import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

import { Context } from '../context/DataContext';

const OrderCard = ({ policyNumber, name, phone, model, onClick }) => {
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6">{policyNumber}</Typography>
        <Typography variant="h6">{name}</Typography>
        <Typography variant="h6">{phone}</Typography>
        <Typography variant="h5">{model}</Typography>
      </CardContent>
      <CardActions>
        <Button fullWidth variant="contained" onClick={onClick}>
          <CheckIcon />
        </Button>
      </CardActions>
    </Card>
  );
};

const SelectPreviousOrderPage = () => {
  const navigate = useNavigate();
  const {
    state: { previousOrders },
    setCustomerInfo,
  } = React.useContext(Context);

  return (
    <Box>
      <Typography variant="h4" sx={{ my: 2 }}>
        選擇欲換機之保單
      </Typography>
      <Box sx={{ px: 3, '& > *': { mb: 2 } }}>
        {previousOrders.length > 0 ? (
          previousOrders.map((props) => (
            <OrderCard
              key={props.orderId}
              onClick={() => {
                setCustomerInfo(
                  { previousInsuranceNo: props.policyNumber },
                  () => {
                    navigate('/specification');
                  }
                );
              }}
              {...props}
            />
          ))
        ) : (
          <Typography variant="h5" sx={{ my: 2 }}>
            沒有符合條件的保單
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default SelectPreviousOrderPage;
